import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

const ConfirmationModal = ({
  showConfirmModal,
  setShowConfirmModal,
  onDeleteClick,
  confirmMessage,
  errorMsg,
  deleteTQLoading,
}) => {
  return (
    <Dialog
      header="Confirmation"
      visible={showConfirmModal}
      onHide={() => {
        if (!showConfirmModal) return;
        setShowConfirmModal(false);
      }}
      style={{ width: "30vw" }}
      closable
      position="top"
      draggable={false}
      resizable={false}
      modal
    >
      <div className="text-center">
        <div className="confirm-message mt-2 mb-4">{confirmMessage}</div>
        <div className="d-flex justify-content-center gap-2 mt-4">
          <Button
            label="Cancel"
            className="px-4 py-2 fw-bold cancel"
            onClick={() => {
              if (!showConfirmModal) return;
              setShowConfirmModal(false);
            }}
          />

          <Button
            label="Delete"
            className="px-4 py-2 fw-bold createClientBtn d-flex align-items-center"
            onClick={onDeleteClick}
            loading={deleteTQLoading}
          />
        </div>
        {errorMsg ? <div className="text-danger mt-3">{errorMsg}</div> : ""}
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
